export default "__VITE_ASSET__6485daeb__"